import { NativeModules, Text, View, SafeAreaView, StyleSheet } from 'react-native';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import Theme from '../../theme';
import { connect } from 'react-redux';
import { defaultScale } from '../../utils/scaling';
import { Field, reduxForm } from 'redux-form';
import { isRequired, minLength8 } from '../../utils/validator';
import { TextInput } from 'fitbeat.react-native-components';
import { CheckBox, FormError } from '../../ui';
import { Button, ButtonTypes } from '../../components';
import { Logger } from '../../utils';

const WAIT_CONNECTION_TIMEOUT = 15000;

class WifiConnectScreenComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      passwordHidden: true,
      isConnecting: false,
      error: null,
    };
  }

  componentDidMount() {
    const { isProtected } = this.props.navigation.state.params;
    if (!isProtected) {
      this.connectToNetwork({ password: '' });
    }
  }

  connectToNetwork = async (values) => {
    this.setState({
      isConnecting: true,
      error: null,
    });
    const { ssid, afterNetworkAdded } = this.props.navigation.state.params;
    const password = values.password || '';

    try {
      Logger.debug('adding wifi network', { ssid });
      const result = await NativeModules.EliteWiFi.connect(ssid, password);
      Logger.debug('wifi added', result);

      if (result) {
        Logger.debug('waiting for internet on newly added wifi network');
        const connection = await NativeModules.EliteWiFi.waitForInternetConnection(WAIT_CONNECTION_TIMEOUT);
        Logger.debug('wifi connection', connection);

        if (connection && connection.network) {
          afterNetworkAdded(connection);
          this.props.navigation.goBack();
        } else {
          throw new Error(this.props.t('errorNotConnectedToNewWifi'));
        }
      }
    } catch (error) {
      Logger.debug('failed to add wifi', error.message);
      this.setState({
        isConnecting: false,
        error,
      });
      return;
    }

    this.setState({ isConnecting: false });
  }

  render() {
    const { t, handleSubmit } = this.props;
    const { passwordHidden, isConnecting, error } = this.state;
    const { ssid, isProtected } = this.props.navigation.state.params;

    return (
      <SafeAreaView style={styles.safeViewContainer}>
        <View style={styles.container}>
          <Text style={styles.enterPasswordText}>{t('enterWifiPassword')}</Text>
          <Text style={styles.networkName}>{ssid}</Text>

          {isProtected && (
            <View>
              <View style={styles.inputMainContainer}>
                <Field
                  forwardRef
                  name='password'
                  editable={!isConnecting}
                  secureTextEntry={passwordHidden}
                  component={TextInput}
                  autoCapitalize='none'
                  placeholder={t('formFields:password')}
                  returnKeyType='done'
                  validate={isProtected ? [isRequired, minLength8] : null}  // todo: better min length, check max length based on security type
                  inputContainerStyle={styles.inputContainerStyle}
                  ref={(ref) => {
                    this.passwordInput = ref;
                  }}
                  onSubmitEditing={handleSubmit(this.connectToNetwork)}
                />
              </View>
              <View style={styles.hidePasswordContainer}>
                <CheckBox
                  size={defaultScale(20)}
                  onPress={() => this.setState({ passwordHidden: !passwordHidden })}
                  isActive={!passwordHidden}
                  inActiveOverrideStyle={styles.checkBoxStyle}
                />
                <Text style={styles.checkBoxText}>{t('showPassword')}</Text>
              </View>
            </View>
          )}

          <View style={styles.buttonContainer}>
            <FormError error={error} />

            <Button
              title={t('connect')}
              containerStyle={styles.buttonStyle}
              onPress={handleSubmit(this.connectToNetwork)}
              buttonType={ButtonTypes.NORMAL}
              isLoading={isConnecting}
              disabled={this.props.invalid}
              overrideFontStyles={styles.buttonTextStyle}
            />
          </View>
        </View>
      </SafeAreaView>
    );
  }
}

const styles = StyleSheet.create({
  safeViewContainer: { flex: 1 },
  container: {
    flex: 1,
    backgroundColor: Theme.WHITE,
    paddingHorizontal: defaultScale(10),
  },
  enterPasswordText: {
    ...Theme.textStyle.heading2,
    paddingVertical: defaultScale(20),
  },
  networkName: {
    ...Theme.textStyle.heading,
  },
  textStyle: {
    ...Theme.textStyle.bodyCopyReg,
  },
  hidePasswordContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  checkBoxStyle: {
    borderColor: Theme.GREY_LIGHT,
     backgroundColor: Theme.GREY_LIGHT,
  },
  inputContainerStyle: {
    padding: defaultScale(10),
    backgroundColor: Theme.WHITE,
    borderWidth: 1,
    borderColor: Theme.GREY_MEDIUM_LIGHT,
  },
  inputMainContainer: {
    paddingVertical: defaultScale(15),
  },
  checkBoxText: {
    ...Theme.textStyle.bodyCopyReg,
    textAlign: 'center',
  },
  buttonTextStyle: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.WHITE,
  },
  buttonContainer: {
    paddingVertical: defaultScale(40),
  },
});

const WifiConnectScreen = translate(['elite'], { wait: true })(
  WifiConnectScreenComponent,
);
export default connect()(reduxForm({ form: 'wifiForm' })(WifiConnectScreen));
